module.exports = __webpack_public_path__ + "static/assets/d71c86529ca45555d806725453c66dd5.png";